"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _intl = require("@kyruus/intl");
var _moment = _interopRequireDefault(require("moment"));
var _addToCalendar = _interopRequireDefault(require("@kyruus/add-to-calendar"));
var _utils = require("../../lib/utils");
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _Tracking = require("../../lib/constants/Tracking");
const propTypes = {
  provider: (0, _propTypes.shape)({
    name: _propTypes.string,
    degrees: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      name: _propTypes.string
    })),
    contacts: (0, _propTypes.shape)({
      contact_type: _propTypes.string
    })
  }).isRequired,
  appointment: (0, _propTypes.shape)({
    start_datetime: _propTypes.string
  }).isRequired,
  location: (0, _propTypes.shape)({
    id: _propTypes.string,
    name: _propTypes.string,
    street1: _propTypes.string,
    street2: _propTypes.string,
    suite: _propTypes.string,
    city: _propTypes.string,
    state: _propTypes.string,
    zip: _propTypes.string
  }).isRequired,
  track: _propTypes.func.isRequired,
  intl: (0, _propTypes.shape)({
    locale: _propTypes.string.isRequired,
    formatMessage: _propTypes.func.isRequired
  }).isRequired
};
const AddToCalendarButton = _ref => {
  let {
    provider,
    appointment,
    location,
    track,
    intl
  } = _ref;
  let startTime = (0, _moment.default)(appointment.start_datetime);
  // hard-coding 30 minutes past the start per KENG-10980
  let endTime = (0, _moment.default)(appointment.start_datetime).add(30, 'minute');
  return /*#__PURE__*/_react.default.createElement(_addToCalendar.default, {
    onEventClick: mode => {
      track(_Tracking.userEvents.ADD_TO_CAL, {
        mode
      });
    },
    text: intl.formatMessage(_messages.default.addToCalendar),
    event: {
      title: intl.formatMessage(_messages.default.calendarEventTitle, {
        provider_name: (0, _utils.formatProviderName)(provider)
      }),
      details: intl.formatMessage(_messages.default.calendarEventDetails, {
        provider_name: (0, _utils.formatProviderName)(provider),
        phone_number: (0, _utils.getMainContactNumber)(provider)
      }),
      location: (0, _utils.formatLocation)(location),
      start: startTime.toISOString(),
      end: endTime.toISOString()
    },
    modeLabels: {
      apple: null,
      google: null,
      outlook: null,
      yahoo: null
    },
    buttonMode: "secondary"
  });
};
AddToCalendarButton.propTypes = propTypes;
var _default = exports.default = (0, _intl.injectIntl)(AddToCalendarButton);
AddToCalendarButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AddToCalendarButton",
  "props": {
    "provider": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "name": {
            "name": "string",
            "required": false
          },
          "degrees": {
            "name": "arrayOf",
            "value": {
              "name": "shape",
              "value": {
                "name": {
                  "name": "string",
                  "required": false
                }
              }
            },
            "required": false
          },
          "contacts": {
            "name": "shape",
            "value": {
              "contact_type": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": true
    },
    "appointment": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "start_datetime": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    },
    "location": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "id": {
            "name": "string",
            "required": false
          },
          "name": {
            "name": "string",
            "required": false
          },
          "street1": {
            "name": "string",
            "required": false
          },
          "street2": {
            "name": "string",
            "required": false
          },
          "suite": {
            "name": "string",
            "required": false
          },
          "city": {
            "name": "string",
            "required": false
          },
          "state": {
            "name": "string",
            "required": false
          },
          "zip": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "intl": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "locale": {
            "name": "string",
            "required": true
          },
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": true
    }
  }
};